import { compPatternRanges, hasCompPattern } from '@/music/arrangement/compPatterns';
import type { PerformanceMeasureOccurrence } from '@/music/score/partPlayback';
import type { Score } from '@/music/score/types';
import { catalogueArrangementFor } from './grooveCatalogue';

/** Only the explicitly supported, generated-comp portion of the catalogue
 * timeline is consumed. Other timeline channels/settings remain dormant. */
export function hasCatalogueCompPattern(score: Pick<Score, 'id' | 'form'>): boolean {
  return hasCompPattern(catalogueArrangementFor(score.id)?.timeline, score.form);
}

export function catalogueCompPatternRanges(
  score: Pick<Score, 'id' | 'form'>,
  occurrences: readonly PerformanceMeasureOccurrence[],
) {
  return compPatternRanges(catalogueArrangementFor(score.id)?.timeline, score.form, occurrences);
}
